import { CommunicationRecipient } from 'types/Communication';

export const getRecipientsToolTipText = (
  recipients: CommunicationRecipient[]
) =>
  recipients?.map((recipient) => (
    <li key={recipient?._id}>{recipient?.name || recipient?.email}</li>
  ));
